import { useMutation } from 'apollo-3';
import { useMemo } from 'react';

import {
  generatePersonalizedDiscountCode as generatePersonalizedDiscountCodeMutation,
  getPersonalizedDiscountCode,
} from 'GraphQL/query/PersonalizedDiscountCode.query';

const useGeneratePersonalizedDiscountCode = (
  classroomId,
  { onCompleted, onError, ...apolloProps }
) => {
  const [generatePersonalizedDiscountCode, { data, loading, error, called }] = useMutation(
    generatePersonalizedDiscountCodeMutation,
    {
      variables: { classroomId: classroomId },
      refetchQueries: [
        {
          query: getPersonalizedDiscountCode,
          variables: {
            classroomId,
          },
        },
      ],
      onCompleted: onCompleted,
      onError: (error) => {
        console.error(error);

        onError?.();
      },
      ...apolloProps,
    }
  );

  return [
    generatePersonalizedDiscountCode,
    {
      data: data?.sfFoGeneratePersonalizedDiscountCode,
      loading,
      error,
      called,
    },
  ];
};

export default useGeneratePersonalizedDiscountCode;
